import { render, staticRenderFns } from "./QuestionType.vue?vue&type=template&id=2468fbb4&scoped=true&"
import script from "./QuestionType.vue?vue&type=script&lang=js&"
export * from "./QuestionType.vue?vue&type=script&lang=js&"
import style1 from "./QuestionType.vue?vue&type=style&index=1&id=2468fbb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2468fbb4",
  null
  
)

export default component.exports